import { render, staticRenderFns } from "./InvoiceRemarksList.vue?vue&type=template&id=28f66c6c&scoped=true&"
import script from "./InvoiceRemarksList.vue?vue&type=script&lang=js&"
export * from "./InvoiceRemarksList.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceRemarksList.vue?vue&type=style&index=0&id=28f66c6c&lang=scss&scoped=true&"
import style1 from "./InvoiceRemarksList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f66c6c",
  null
  
)

export default component.exports